/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum TooltipAlignmentEnum {
    RIGHT = 'RIGHT',
    LEFT = 'LEFT'
}
